import { createFileRoute } from '@tanstack/react-router';
import { Receipt } from 'lucide-react';
import { SelectionPlaceholder } from '@/components/molecules';

export const Route = createFileRoute('/_dashboard/dashboard/credit-memos/')({
  component: CreditMemosIndexPanel,
});

function CreditMemosIndexPanel() {
  return (
    <SelectionPlaceholder
      icon={Receipt}
      title="Select a credit memo"
      iconClassName="h-10 w-10 opacity-30"
      className="flex h-full flex-col items-center justify-center gap-3 text-muted-foreground"
    />
  );
}
